import { useStore } from '@/store'
import { DirectiveBinding } from 'vue'

function checkPermission(el: HTMLElement, binding: DirectiveBinding) {
	const { value } = binding
	const role = useStore().state.user.userInfo.userinfo.role;
	const uid = useStore().state.user.userInfo.userinfo.id; //特殊用户过滤
	const coid = useStore().state.user.userInfo.schooleinfo.coid; //特殊学校过滤
	if(!role) {
		setTimeout(() => {
			checkPermission(el, binding)
		}, 200);
		return;
	}
	if (({}).toString.call(value) === "[object Array]") {
		if ((value.length > 0 && !value.includes(role) && !value.includes(uid) && !value.includes(coid)) ) {
			el.style.display = 'none'
		} else {
			el.style.display = ''
		}
	} else {
		throw new Error(`need roles! Like v-role="['0','1']"`)
	}
}

export default {
	mounted(el: HTMLElement, binding: DirectiveBinding) {
		checkPermission(el, binding)
	}
}
